import { InteractionStatus } from '@azure/msal-browser';
import { useMsal } from '@azure/msal-react';
import LoadingPage from '@viking-eng/loading-page';
import MvjPropTypes from '@viking-eng/prop-types';
import PropTypes from 'prop-types';

import PermissionError from 'components/PermissionError/PermissionError';
import { hasAnyRole } from 'utils/auth';

const PrivateRoute = ({ element, requiredRoles }) => {
  const { inProgress, instance: msalInstance } = useMsal();
  const account = msalInstance.getActiveAccount();

  const isAuthenticated = account?.idTokenClaims;
  const userRoles = account?.idTokenClaims?.roles || [];

  if (inProgress !== InteractionStatus.None || !isAuthenticated) {
    return <LoadingPage loaded={false} variant="blue" />;
  }

  if (requiredRoles?.length && !hasAnyRole(userRoles, requiredRoles)) {
    return <PermissionError requiredRoles={requiredRoles} userRoles={userRoles} />;
  }

  return element;
};

PrivateRoute.propTypes = {
  element: PropTypes.oneOfType([MvjPropTypes.jsx, PropTypes.func]).isRequired,
  requiredRoles: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default PrivateRoute;
